import { createFileRoute } from '@tanstack/react-router';

import { CanvasGallery } from '~/features/dev/canvas-gallery';

/** The setup canvas drawn from a fixture, with no server. A developer page, open to anyone. */
export const Route = createFileRoute('/dev/canvas')({ component: CanvasGallery });
